export default "__VITE_ASSET__BWGIFbP0__"